import { Component, OnInit, OnDestroy, ChangeDetectionStrategy, ChangeDetectorRef, Input } from '@angular/core';
import { BannerMessage } from '@model';
import { Store } from '@ngrx/store';
import * as fromInformationStore from '@core/store';
import { SubSink } from 'subsink';
import { filter, take } from 'rxjs';
import { BusinessArea } from 'app/models/enums/business-area.enum';

@Component({
    selector: 'app-contextual-system-message-pane',
    templateUrl: './contextual-system-message-pane.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ContextualSystemMessagePaneComponent implements OnInit, OnDestroy {

  @Input()
  cssClass: string;

  @Input()
  businessArea: BusinessArea = BusinessArea.All;

  contextualMessages: BannerMessage[] = [];
 
  private subs = new SubSink();

  constructor(private informationStore: Store<fromInformationStore.InformationState>,
    private changeDetectorRef: ChangeDetectorRef) { }

  ngOnInit() {

    this.informationStore
      .select(fromInformationStore.getInformationLoaded)
      .pipe(
        filter(x => !x),
        take(1)
      )
      .subscribe(x => {
        this.informationStore.dispatch(new fromInformationStore.LoadBanners());
      });

      this.subs.sink = this.informationStore.select(fromInformationStore.getContextualBannerMessages).subscribe(banners => {
      if(this.businessArea != BusinessArea.All) {
        this.contextualMessages = banners.filter(b => b.businessArea === this.businessArea || b.businessArea === BusinessArea.All);
      } else {
        this.contextualMessages = banners;
      }
     
      this.changeDetectorRef.detectChanges();
    });
  }

  ngOnDestroy() {
    this.changeDetectorRef.detach();
    this.subs.unsubscribe();
  }
}
